module.exports = __webpack_public_path__ + "static/media/workAntihumidity1.a09762a7.jpg";